/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { ISwapMutation, ISwapMutationInterface } from "../ISwapMutation";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint32[72]",
        name: "geneticSequence",
        type: "uint32[72]",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "swapMutation",
    outputs: [
      {
        internalType: "uint32[72]",
        name: "",
        type: "uint32[72]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class ISwapMutation__factory {
  static readonly abi = _abi;
  static createInterface(): ISwapMutationInterface {
    return new utils.Interface(_abi) as ISwapMutationInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISwapMutation {
    return new Contract(address, _abi, signerOrProvider) as ISwapMutation;
  }
}
